import Carousel, { CarouselProps } from '../../../molecules/carousel/Carousel'
import React, { FunctionComponent } from 'react'
import { SectionProps } from '../Sections'

export interface CarouselSectionProps extends CarouselProps, SectionProps {}

const CarouselSection: FunctionComponent<CarouselSectionProps> = ({
  className,
  images,
  name,
}) => <Carousel className={className} images={images} name={name} />

export default CarouselSection
